export const quoteDetailsList = [
    {
        "name": 'John',
        "status": 'Approved',
        "rating" : "4.2",
        "amount" : "41.20"
    }, 
    {
        "name": 'Martin',
        "status": 'Rejected',
        "rating" : "4.2",
        "amount" : "40.00"
    }, 
    {
        "name": 'Antony',
        "status": 'Rejected',
        "rating" : "4.2",
        "amount" : "38.00"
    }
]

export const jobStatusList = [
    { 'value': 'Submitted', 'label': 'Sumbitted'},
    { 'value': 'Approved', 'label': 'Approved'},
    { 'value': 'On Hold', 'label': 'On Hold' },
    { 'value': 'Rejected', 'label': 'Rejected' },
    { 'value': 'With Qualification', 'label': 'With Qualification' },
    { 'value': 'Without Qualification', 'label': 'Without Qualification' }
]

export const items= [
    {
        "name": 'Item1',
        "quantity": 2,
        "price" : "15.00"
    },
    {
        "name": 'Item2',
        "quantity": 1,
        "price" : "11.20"
    }
]

export const invoices= [
    {
        "name": 'Item1',
        "invoice": "Parts invoice1.pdf",
    },
    {
        "name": 'Item2',
        "invoice": "Parts invoice1.pdf",
    }
]

